import * as React from 'react';
import { Dispatch } from 'redux';
import { CreateUserViewModel } from 'stageclip-common';

import { BaseApiGetRequest } from '../generic/baseApiGetRequest';
import * as EntityNormalizers from '../normalizers/entityNormalizers';

import { normalizerClientsUsersData } from './clients.normalizers';

export class FetchClientsUsers extends BaseApiGetRequest<
  CreateUserViewModel[],
  EntityNormalizers.NormalizedEntityArray<CreateUserViewModel>
> {
  constructor(id: string, component: React.Component, dispatch: Dispatch) {
    super(component, dispatch);

    this.path = `/clients/${id}/users`;
    this.normalizeMethod = normalizerClientsUsersData as any;
  }
}
